import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import consts from './consts'
import { i18n, translate } from './lang'
import axios from 'axios'
import VueAxios from 'vue-axios'
import SocialSharing from 'vue-social-sharing'
import VueTextareaAutosize from 'vue-textarea-autosize'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMatomo from 'vue-matomo'
import VueAnalytics from 'vue-analytics'
import createGtm from 'vue-gtm'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)
Vue.use(VueAxios, axios)
Vue.use(SocialSharing)
Vue.use(VueTextareaAutosize)

Vue.prototype.$consts = consts

Vue.mixin({
  methods: {
    $tr: translate
  }
})

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

let app, settings

window.initApp = (collegeSettings, cfg) => {
  settings = {
    apiBaseURL: cfg.VUE_APP_API_BASE_URL,
    googleMapsKey: cfg.VUE_APP_GOOGLE_MAPS_KEY,
    piwikHost: cfg.VUE_APP_PIWIK_HOST,
    sentryDSN: cfg.VUE_APP_SENTRY_DSN,
    nameCaptureBaseUrl: cfg.VUE_APP_NAME_CAPTURE_BASE_URL
  }
  Vue.axios.defaults.baseURL = settings.apiBaseURL

  Vue.use(VueGoogleMaps, {
    load: {
      key: settings.googleMapsKey,
      libraries: 'places' // This is required if you use the Autocomplete plugin
    },
    installComponents: true
  })

  store.commit('setCollege', collegeSettings)
  store.dispatch('getLanguage')
  store.dispatch('student/getStudentGUID').then(() => store.dispatch('student/getStudentNotes'))
  store.dispatch('poi/loadSavedPoiList')
  store.dispatch('poi/loadUnfinishedTour')
  store.dispatch('personalized/loadSelectedPoiList')

  if (collegeSettings.piwikId) {
    Vue.use(VueMatomo, {
      host: settings.piwikHost,
      siteId: collegeSettings.piwikId,
      router: router
    })
  }

  if (collegeSettings.gaId) {
    Vue.use(VueAnalytics, {
      id: collegeSettings.gaId,
      router
    })
  }

  if (collegeSettings.gtmId) {
    Vue.use(createGtm, {
      id: collegeSettings.gtmId,
      router
    })
  }

  app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')

  if (settings.sentryDSN) {
    Sentry.init({
      dsn: settings.sentryDSN,
      integrations: [new Integrations.Vue({ app, attachProps: true })]
    })
  }
}

export { app as default, settings }
